import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "../lib/api";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { publicApi.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  const featured = posts.find((p) => p.featured) || posts[0];
  const rest = posts.filter((p) => p.id !== featured?.id);

  return (
    <div>
      <Seo
        title="The Journal — Field Notes from Voyage Luxe"
        description="Travel essays, destination guides, and concierge wisdom from the Voyage Luxe atelier. Honeymoon, Japan cherry blossom, Rajasthan in monsoon, Kerala Ayurveda."
      />
      {/* Hero */}
      <section className="pt-40 md:pt-48 pb-12 container-luxe">
        <div className="eyebrow mb-6">The Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-balance max-w-5xl">
          Field notes<br /><span className="italic">from the atelier</span>.
        </h1>
      </section>

      {/* Featured */}
      {featured && (
        <section className="container-luxe py-16">
          <Reveal>
            <Link to={`/journal/${featured.slug}`} className="group block" data-testid="blog-featured">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7 aspect-[4/3] overflow-hidden">
                  <img src={featured.image} alt={featured.title} className="h-full w-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-105" />
                </div>
                <div className="lg:col-span-5">
                  <div className="eyebrow text-accent mb-4">Featured · {featured.category}</div>
                  <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight group-hover:text-accent transition-colors">{featured.title}</h2>
                  <p className="mt-6 text-foreground/70 leading-relaxed">{featured.excerpt}</p>
                  <div className="mt-6 text-[11px] uppercase tracking-[0.25em] text-foreground/55">{featured.author} · {featured.date} · {featured.read_time}</div>
                </div>
              </div>
            </Link>
          </Reveal>
        </section>
      )}

      {/* Grid */}
      <section className="py-16 container-luxe">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {rest.map((p, i) => (
            <Reveal key={p.id || p.slug} delay={i * 80}>
              <Link to={`/journal/${p.slug}`} className="group block" data-testid={`blog-${p.slug}`}>
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-105" />
                </div>
                <div className="mt-5 eyebrow text-foreground/55">{p.category} · {p.read_time}</div>
                <h3 className="mt-2 font-serif text-2xl md:text-3xl leading-tight group-hover:text-accent transition-colors">{p.title}</h3>
                <p className="mt-3 text-sm text-foreground/65 leading-relaxed">{p.excerpt}</p>
                <div className="mt-4 text-[11px] uppercase tracking-[0.25em] text-foreground/55">{p.author} · {p.date}</div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
